import styled from "styled-components/macro";

export const ListingCardGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, 332.7px);
  gap: 30px;
`;
